

// $(document).ready(function(){

// $(document).on('click', '.vip_add_to_cart', function(){

// setTimeout(function() {

//     const variantId = 64992946291037;
//      $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         dataType: 'json',
//         success: function (cart) {
//             let isInCart = false;


//             cart.items.forEach(function (item) {
//                 if (item.variant_id === variantId) {
//                     isInCart = true;
//                 }
//             });


//             if (isInCart) {
//                 // Update the quantity to 1
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/update.js',
//                     data: {
//                         updates: {
//                             [variantId]: 1
//                         }
//                     },
//                     dataType: 'json',
//                     success: function (response) {
                      
//                             $('.vip_guest_add_to_cart').click();
                       
//                     },
//                     error: function (error) {
//                         console.error('Error updating cart:', error);
//                     }
//                 });
//             } else {
//                 $.ajax({
//                     type: 'POST',
//                     url: '/cart/add.js',
//                     data: {
//                         id: variantId,
//                         quantity: 1,
//                         {% comment %} selling_plan: sellingPlan {% endcomment %}
//                     },
//                     dataType: 'json',
//                     success: function (response) {
                       
//                           $('.vip_guest_add_to_cart').click();
                       
//                     },
//                     error: function (error) {
//                         console.error('Error adding product to cart:', error);
//                     }
//                 });
//             }
//         },
//         error: function (error) {
//             console.error('Error fetching cart:', error);
//         }
//     });
// }, 800);
// });


// });



document.addEventListener('click', function (e) {
  if (!e.target.closest('.vip_add_to_cart')) return;

  setTimeout(function () {
    const variantId = 64992946291037;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const isInCart = cart.items.some(function (item) {
          return item.variant_id === variantId;
        });

        if (isInCart) {
          // Update quantity to 1
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              updates: { [variantId]: 1 }
            })
          });
        } else {
          // Add to cart
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
              // selling_plan: sellingPlan
            })
          });
        }
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        const guestBtn = document.querySelector('.vip_guest_add_to_cart');
        if (guestBtn) guestBtn.click();
      })
      .catch(function (error) {
        console.error('Error handling cart update:', error);
      });
  }, 800);
});